module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/DIRECTIVES_PACK_30.67ef0c57.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/DIRECTIVES_PACK_30.png
// module id = 1147
// module chunks = 16